import { css } from '@emotion/css';

export const setBackground = (background: string) => css`
  background: ${background};
`;

export const setColor = (color?: string) => css`
  color: ${color || 'var(--text-paragraph)'};
`;
